module.exports = __webpack_public_path__ + "img/21.6196d38d.png";